export const FETCH_MESSAGE_DETAILS = "FETCH_MESSAGE_DETAILS"
export const FETCH_MESSAGE_DETAILS_SUCCESSFUL = "FETCH_MESSAGE_DETAILS_SUCCESSFUL"
export const FETCH_MESSAGE_DETAILS_FAILED = "FETCH_MESSAGE_DETAILS_FAILED"